module.exports = __webpack_public_path__ + "images/stickers/rocketship@2x.6e898c0f17c02ecdc018.png";